import { createAsyncThunk } from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

export const fetchUsersAsync = createAsyncThunk(
  'admin/getUser',
  async function (payload: { paginationdata: { page_num: number; page_limit: number, search: string } }, toolkit) {
    return await AxiosClient('GET', '/superadmin/manage-user', [], toolkit, payload.paginationdata)
  }
)

export const fetchUsersForDropDownAsync = createAsyncThunk(
  'admin/getUserForDropDown',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/get-users-for-dropdown', [], toolkit, [])
  }
)

export const getUserByIdAsync = createAsyncThunk(
  'admin/getUserByIdAsync',
  async function (payload: { id: number }, toolkit) {
    console.log("payload.id", payload.id);

    const url = `/superadmin/manage-user?user_id=${payload.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)

type payloadForAddUser = {
  name: string;
  email: string;
  role: string;
  role_id: number;
  is_active: boolean;
  is_notify: boolean;
  customer_ids: string | null;
  is_access_all_customer: boolean;
}
export const addManagerAsync = createAsyncThunk(
  'admin/addManager',
  async function (payload: payloadForAddUser, toolkit) {
    return await AxiosClient('POST', '/superadmin/manage-user', payload, toolkit, [])
  }
)

type payloadForEditUser = {
  id: number;
  name: string;
  email: string;
  role: string;
  role_id: number;
  is_active: boolean;
  customer_ids: string;
}
export const editManagerAsync = createAsyncThunk(
  'admin/editManagerAsync',
  async function (payload: payloadForEditUser, toolkit) {
    const url = `/superadmin/manage-user`
    return await AxiosClient('PUT', url, payload, toolkit, [])
  }
)

export const putManagerAsync = createAsyncThunk(
  'admin/putManagerAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/${payload.id}`
    return await AxiosClient('PUT', url, payload, toolkit, [])
  }
)

export const deleteManagerAsync = createAsyncThunk(
  'admin/deleteManagerAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/superadmin/manage-user?user_id=${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)


//ROLES
export const getRoleAsync = createAsyncThunk(
  'admin/getRoleAsync',
  async function (payload, toolkit) {
    return await AxiosClient('GET', '/superadmin/manage-role', payload, toolkit, [])
  }
)

export const getRoleByIdAsync = createAsyncThunk(
  'admin/getRoleAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/superadmin/manage-role?role_id=${payload.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)

interface RolePayload {
  name: string;
  customer_access: string;
  manage_plan_access: string;
  report_access: string;
  user_access: string;
}

export const addRoleAsync = createAsyncThunk(
  'admin/addRoleAsync',
  async function (payload: RolePayload, toolkit) {
    return await AxiosClient('POST', '/superadmin/manage-role', payload, toolkit, [])
  }
)

export const updateRoleAsync = createAsyncThunk(
  'admin/updateRoleAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/superadmin/manage-role`
    return await AxiosClient('PUT', url, payload, toolkit, [])
  }
)

export const deleteRoleAsync = createAsyncThunk(
  'admin/deleteRoleAsync',
  async function (payload: { id: number }, toolkit) {
    console.log("payload", payload.id);
    const url = `/superadmin/manage-role?role_id=${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

//  -----------STAFF ACTION ENDPOINTS--------------------------------------------------------------------------------------------------------------------

// ROLE STAFF ACTIONS ENDPOINTS------------------------------------------------------------------------
export const getRoleStaffList = createAsyncThunk(
  'user/getRoleStaffList',
  async function (payload:{paginationdata: {page_num: number; page_limit: number,search?: string,order_by?:string,sort_by?:string, is_available?:boolean}}, toolkit) {
    return await AxiosClient('GET', `/superadmin/manage-user-role`, [], toolkit, payload.paginationdata )
  }
)
export const createRoleStaff = createAsyncThunk(
  'user/createRoleStaff',
  async function (payload: {}, toolkit) {
    return await AxiosClient('POST', `/superadmin/manage-user-role`, payload, toolkit, [])
  }
)
export const getEditRoleStaff = createAsyncThunk(
  'admin/getEditRoleStaff',
  async function (payload: { id: number }, toolkit) {
    const url = `/superadmin/manage-user-role/${payload.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)

export const updateRoleStaff = createAsyncThunk(
  'admin/updateRoleStaff',
  async function (payload: { id: number, body }, toolkit) {
    const url = `/superadmin/manage-user-role/${payload.id}`
    return await AxiosClient('PUT', url, payload?.body, toolkit, [])
  }
)
export const deleteRoleStaff = createAsyncThunk(
  'admin/deleteRoleStaff',
  async function (payload: { id: number }, toolkit) {
    console.log("payload", payload.id);
    const url = `/superadmin/manage-user-role/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// -----------USER STAFF ACTION ENDPOINTS---------------------------------------------------------------
export const getUserStaffList = createAsyncThunk(
  'user/getUserStaffList',
  async function (payload: { paginationdata: { page_num: number; page_limit: number, search?: string, order_by?: string, sort_by?: string } }, toolkit) {
    return await AxiosClient('GET', `/superadmin/manage-staff`, [], toolkit, payload.paginationdata)
  }
)
export const createUserStaff = createAsyncThunk(
  'user/createUserStaff',
  async function (payload: {}, toolkit) {
    return await AxiosClient('POST', `/superadmin/manage-staff`, payload, toolkit, [])
  }
)

export const getEditUserStaff = createAsyncThunk(
  'admin/getEditUserStaff',
  async function (payload: { id: number }, toolkit) {
    const url = `/superadmin/manage-staff/${payload.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)

export const updateUserStaff = createAsyncThunk(
  'admin/updateUserStaff',
  async function (payload: { id: number, body: {} }, toolkit) {
    const url = `/superadmin/manage-staff/${payload.id}`
    return await AxiosClient('PUT', url, payload?.body, toolkit, [])
  }
)

export const deleteUserStaff = createAsyncThunk(
  'admin/deleteUserStaff',
  async function (payload: { id: number }, toolkit) {
    console.log("payload", payload.id);
    const url = `/superadmin/manage-staff/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// ---------GET ROLES PERMISSION LIST----------------------------------------------------------------------------------------
export const getRolePermissionListStaff = createAsyncThunk(
  'admin/getRolePermissionListStaff',
  async (_, thunkAPI) => {
    return AxiosClient('GET', '/superadmin/role-and-permissions', null, thunkAPI, {})
  }
);
export const getMenuList = createAsyncThunk(
  'admin/getMenuList',
  async (_, thunkAPI) => {
    try {
      const response = await AxiosClient(
        'GET',
        '/superadmin/menu-list',
        null,
        thunkAPI,
        {}
      )
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)
